import React from 'react'
import {createPortal} from "react-dom";

export const Portal = (props: any) => {
  const Popup = createPortal(props.children, document.body);
  return Popup;
};